// extracted by mini-css-extract-plugin
export default {"filterButton":"GroupsFilterButton_filterButton__rA6xq","filterButtonIcon":"GroupsFilterButton_filterButtonIcon__Hb-Pq"};